import * as React from 'react';
import { FormField, Input, InputAdornment, MaskedInput } from '@cian/ui-kit';
import { Form, useField } from 'formik';

import { FORM_PHONE_MASK, FORM_PHONE_PREFIX } from '../../../../containers/LeaveContactsDialogContainer/constants';

import * as styles from './styles.css';

interface ILeaveContactsFormProps {
  isDesktop: boolean;
  isSubmitting: boolean;
}

export const LeaveContactsForm: React.FC<ILeaveContactsFormProps> = ({ isDesktop, isSubmitting }) => {
  const [phoneField, phoneMeta, phoneHelpers] = useField<string>('phone');
  const [nameField, nameMeta] = useField<string>('name');

  return (
    <section className={styles['container']} data-testid="leave-contacts-dialog-form">
      <Form aria-label="Оставить контакты">
        <FormField label="Ваше имя" errorMessage={nameMeta.touched ? nameMeta.error : null} required>
          <Input
            aria-label="Ваше имя"
            placeholder="Иванов Иван"
            size={isDesktop ? 'XS' : 'M'}
            name="name"
            value={nameField.value}
            onChange={nameField.onChange}
            onBlur={nameField.onBlur}
            disabled={isSubmitting}
            maxLength={70}
          />
        </FormField>
        <FormField label="Телефон" errorMessage={phoneMeta.touched ? phoneMeta.error : null} required>
          <MaskedInput
            aria-label="Ваш телефон"
            size={isDesktop ? 'XS' : 'M'}
            name="phone"
            leftAdornment={<InputAdornment>{FORM_PHONE_PREFIX}</InputAdornment>}
            value={phoneField.value}
            onChange={value => {
              phoneHelpers.setValue(value);
            }}
            onBlur={phoneField.onBlur}
            mask={FORM_PHONE_MASK}
            disabled={isSubmitting}
          />
        </FormField>
      </Form>
    </section>
  );
};
